import { SiteQueryFieldParamPlugin } from './SiteQueryFieldParamPlugin';
import { SiteRouteParamPlugin } from './SiteRouteParamPlugin';
export const defaultSiteParamPlugins = [
    SiteQueryFieldParamPlugin,
    SiteRouteParamPlugin
];
//# sourceMappingURL=default.js.map